const API = import.meta.env.VITE_API_URL || 'http://localhost:4000/api';

export default function WelcomePage() {
  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f3f4f6',
      fontFamily: 'system-ui, sans-serif',
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 16,
        padding: '48px 40px',
        width: '100%',
        maxWidth: 420,
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
        textAlign: 'center',
      }}>
        <div style={{
          width: 56, height: 56, borderRadius: 14,
          background: '#ede9fe', display: 'inline-flex',
          alignItems: 'center', justifyContent: 'center',
          fontSize: 28, marginBottom: 16,
        }}>
          ☁
        </div>

        <h1 style={{ margin: '0 0 8px', fontSize: 24, fontWeight: 700, color: '#111' }}>
          CoSec Drive
        </h1>
        <p style={{ margin: '0 0 32px', color: '#6b7280', fontSize: 15 }}>
          Connect your Google Drive to manage client documents directly from CoSecOffice.
        </p>

        <a
          href={`${API}/storage/google/auth-connect`}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 12,
            padding: '12px 24px',
            background: '#fff',
            border: '1px solid #d1d5db',
            borderRadius: 8,
            fontSize: 15,
            fontWeight: 600,
            color: '#111',
            textDecoration: 'none',
            boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
            cursor: 'pointer',
          }}
        >
          <GoogleIcon />
          Continue with Google
        </a>

        <p style={{ marginTop: 24, fontSize: 12, color: '#9ca3af' }}>
          Only your Google Drive files are accessed. No data is stored except encrypted OAuth tokens.
        </p>
      </div>
    </div>
  );
}

function GoogleIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 48 48">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
    </svg>
  );
}
